import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type Carer = {
  id: string;
  email: string;
  name: string;
  photo_url?: string;
  bio?: string;
  care_types?: string[];
  skills?: string[];
  hourly_rate?: number;
  service_area?: string;
  verification_status: string;
  availability_dates?: {
    startDate?: string;
    endDate?: string;
  };
};

const useCarers = () => {
  const queryFn = async (): Promise<Carer[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_all_carers', {
      method: 'POST',
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.carers || [];
  };

  return useQuery<Carer[], Error>({
    queryKey: ['carers'],
    queryFn,
  });
};

export default useCarers;
